/**
 * @module ol/source/common
 */

/**
 * Default WMS version.
 * @type {string}
 */
export const DEFAULT_WMS_VERSION = '1.3.0';

/**
 * Context options to disable image smoothing.
 * @type {Object}
 */
export const IMAGE_SMOOTHING_DISABLED = {
  imageSmoothingEnabled: false,
  msImageSmoothingEnabled: false,
};
